<template>
  <div class="wrapper">
    <div class="effective">
      <!-- 左半部分 -->
      <div class="left-effective">
        <div class="">
          <div class="title-effective" style="min-width: 85px;">
            备案号：
          </div>
          <div class="context">
            {{WarnInfoData.BRFilingCode}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective" style="min-width: 83px;">
            经营方式：
          </div>
          <div class="context">
            {{WarnInfoData.BRBusinessMode}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective" style="min-width: 83px;">
            库房地址：
          </div>
          <div class="context">
            {{WarnInfoData.BRWarehouseAddr}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective" style="min-width: 83px;">
            企业负责人：
          </div>
          <div class="context">
             {{WarnInfoData.BRCEO}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective" style="min-width: 83px;">
            备案日期：
          </div>
          <div class="context">
           {{WarnInfoData.BRFilingDate}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective">
            第二类医疗器械备案凭证
          </div>
          <div class="" style="  position: relative;left: -20px;top: -40px;">
            <CommonuploadEnclosure ref="UploadEnclisureRef" :typeUpload="3" title="" :BLPhotoURL="WarnInfoData.BRPhotoURL"></CommonuploadEnclosure>
          </div>
        </div>

      </div>
      <!--右半部分-->
      <div class="right-effective">
        <div class="">
          <div class="title-effective" style="min-width: 85px;">
            企业名称：
          </div>
          <div class="context">
            {{WarnInfoData.BRCompanyName}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective" style="min-width: 85px;">
            经营场所：
          </div>
          <div class="context">
            {{WarnInfoData.BRBusinessAddr}}
          </div>
        </div>

        <div class="border-context">
          <div class="title-effective" style="min-width: 85px;">
            法定代表人：
          </div>
          <div class="context">
            {{WarnInfoData.BRLegalRepresentative}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective" style="min-width: 85px;">
            经营范围：
          </div>
          <div class="context">
            {{WarnInfoData.BRSecInvSort}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective" style="min-width: 85px;">
            住所：
          </div>
          <div class="context">
            {{WarnInfoData.BRAddress}}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="reject-Overdue">
      <img src="@/assets/channel/reject.png" alt="" style="width: 24px;height:24px;vertical-align: middle;margin-right: 10px;">
      医疗器械经营许可证 即将过期，请及时更新。
    </div> -->
  </div>
</template>

<script>
import CommonuploadEnclosure from '../../../../../../../components/common-upload-Enclosure.vue'
export default {
  components: { CommonuploadEnclosure },
  props: {
    WarnInfoData: {
        type: undefined
      }
  },
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
@import url(../../style/index.less);
</style>